import { Injectable, Inject } from '@angular/core';
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { IFormAccomodations } from "../Models/Forms/IFormAccomodations";

@Injectable()
export class FormAccomodationsService extends BaseService {
    _baseUrl: string = "";

    constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        super(_http);
        this._baseUrl = baseUrl;
    }

    getFormAccomodations(id: number) {
        return this._http.get(this._baseUrl + "api/FormAccommodations/" + id)
            .map((response: IFormAccomodations) => response as IFormAccomodations)
            .catch(this.errorHandler);
    }

    insertUpdateFormAccomodations(formAccomodationsDetails: IFormAccomodations) {
        return this._http.post(this._baseUrl + 'api/FormAccommodations', formAccomodationsDetails)
            .map((response: IFormAccomodations) => response as IFormAccomodations)
            .catch(this.errorHandler);
    }

    deleteAccomodations(id) {
        return this._http.delete(this._baseUrl + "api/FormAccomodations" + id)
            .map((response: IFormAccomodations) => response as IFormAccomodations)
            .catch(this.errorHandler)
    }

    errorHandler(error: Response) {
        console.log(error);
        return Observable.throw(error);
    }

}



